
























































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import WipTicket from "@/domainObjects/wip/WipTicket";
import DiscrepancyPicker from "@/view/shared-components/DiscrepancyPicker.vue";
import Discrepancy from "@/domainObjects/wip/Discrepancy";

    @Component({
        components: {DiscrepancyPicker}
    })

    export default class WipCauseForm extends Vue {
        @Prop({required: true}) wipTicket!: WipTicket;
        @Prop({required: true}) type!: String;

        selectDiscrepancy(value) {
            this.wipTicket.discrepancy = value;
            this.wipTicket.discrepancy.id = value.id;
        }

      @Watch('isMissing')
      onResetMissingDetails(newValue: boolean, oldValue:boolean){
        if (newValue !== oldValue) {
          this.wipTicket.missingPartQty = 0;
          this.wipTicket.missingPartNumber = ''
        }
      }

      get isMissing(): boolean {
        return Discrepancy.isMissing(this.wipTicket.discrepancy)
      }
    }
